import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './PageStyles.css';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="legal-title">{t('terms.title')}</h1>
          <p className="legal-date">{t('terms.lastUpdated')}: 12.12.2025</p>
          
          <div className="legal-content">
            <section>
              <h2>{t('terms.section1.title')}</h2>
              <p>{t('terms.section1.content')}</p>
            </section>

            <section>
              <h2>{t('terms.section2.title')}</h2>
              <p>{t('terms.section2.content')}</p>
            </section>

            <section>
              <h2>{t('terms.section3.title')}</h2>
              <p>{t('terms.section3.content')}</p>
            </section>

            <section>
              <h2>{t('terms.section4.title')}</h2>
              <p>{t('terms.section4.content')}</p>
            </section>

            <section>
              <h2>{t('terms.section5.title')}</h2>
              <p>{t('terms.section5.content')}</p>
            </section>

            <section>
              <h2>{t('terms.contact.title')}</h2>
              <p>{t('terms.contact.content')}</p>
              <p>E-posta: info@ustaconsulting.com</p>
              <p>Telefon: +90 (533) 775 71 81</p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
